import { useParams } from "react-router-dom";

import Header from "@/components/Header";
import { MainContainer } from "@/components/Layout/Styled";
import { BlockLoader } from "@/components/UI/BlockLoader";
import { useMarket } from "@/hooks/useMarket";
import NotFound from "@/routes/Pages/NotFound";

import { MarketVerifyAddressPage } from "./MarketVerifyAddressPage";

export const MarketVerifyAddress = () => {
    const { marketId } = useParams();

    const safeMarketId = marketId ?? "";

    const { market, marketLoading } = useMarket(safeMarketId);

    if (marketLoading) {
        return (
            <>
                <Header back title="Верифікація адреси" />
                <MainContainer>
                    <BlockLoader />
                </MainContainer>
            </>
        );
    }

    if (!market || !!market?.address?.id) {
        return <NotFound />;
    }

    return <MarketVerifyAddressPage market={market} />;
};

export default MarketVerifyAddress;
